import { HttpClient } from './http.service';
import { NotificationService } from './notification.service';
import { Inject, Injectable, NgModule } from '@angular/core';
import { Folder } from '../treeable/shared/folder.model';
import { Observable } from 'rxjs/Observable';
/**
 * Service allows opertions against dotCMS Folder Endpoints and Operations
 */
var FolderService = (function () {
    function FolderService(httpClient, notificationService) {
        this.httpClient = httpClient;
        this.notificationService = notificationService;
    }
    /**
     * Load a folder from the remote dotCMS server based on site and path
     * @param {String} siteName The site name for the uri/folder
     * @param {String} uri The folder path
     */
    FolderService.prototype.loadFolderByURI = function (siteName, uri) {
        var _this = this;
        return this.httpClient.get('/api/v1/folder/sitename/' + siteName + '/uri/' + uri)
            .map(function (res) { return _this.extractDataFilter(res); })
            .catch(function (error) { return _this.handleError(error); });
    };
    FolderService.prototype.extractDataFilter = function (res) {
        var folder;
        var obj = JSON.parse(res.text());
        var result = Object.assign(new Folder(), obj.entity);
        return result;
    };
    FolderService.prototype.handleError = function (error) {
        var errMsg = (error.message) ? error.message :
            error.status ? error.status + " - " + error.statusText : 'Server error';
        if (errMsg) {
            console.log(errMsg);
            this.notificationService.displayErrorMessage('There was an error; please try again : ' + errMsg);
            return Observable.throw(errMsg);
        }
    };
    return FolderService;
}());
export { FolderService };
FolderService.decorators = [
    { type: Injectable },
    { type: Inject, args: ['httpClient',] },
    { type: Inject, args: ['notificationService',] },
];
/** @nocollapse */
FolderService.ctorParameters = function () { return [
    { type: HttpClient, },
    { type: NotificationService, },
]; };
var DotFolderModule = (function () {
    function DotFolderModule() {
    }
    return DotFolderModule;
}());
export { DotFolderModule };
DotFolderModule.decorators = [
    { type: NgModule, args: [{
                providers: [FolderService, HttpClient, NotificationService]
            },] },
];
/** @nocollapse */
DotFolderModule.ctorParameters = function () { return []; };
//# sourceMappingURL=folder.service.js.map